<template>
    <div class="p-1">
        <div>
            <img :src="src" />
        </div>
        <p>{{ filename }}</p>
    </div>
</template>

<script>
export default {
    name: "photo-question-image",
    props: {
        photo: {
            type: Object,
            required: true,
        },
    },
    computed: {
        filename() {
            return this.photo.filename;
        },
        src() {
            let src = this.photo.content;
            return `data:image/png;base64,${src}`;
        },
    },
};
</script>